import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const exportPDF = ({
  title = "Exported Data",
  fileName = "data",
  columns = [],
  data = [],
  logo = "/assets/logo.png",
  company = {
    name: "Ndoto Company Limited",
    address: "P.O. Box 1234, Kampala, Uganda",
    contact: "Email: info@ndototech.com | Tel: +256 789 000 000",
  },
}) => {
  const doc = new jsPDF();

  // Add Logo
  const img = new Image();
  img.src = logo;

  img.onload = () => {
    doc.addImage(img, "PNG", 10, 10, 30, 30); // x, y, w, h

    // Add Company Info
    doc.setFontSize(14);
    doc.text(company.name, 45, 15);
    doc.setFontSize(10);
    doc.text(company.address, 45, 22);
    doc.text(company.contact, 45, 28);

    // Line separator
    doc.line(10, 35, 200, 35);

    // Title and Table
    doc.setFontSize(12);
    doc.text(title, 10, 45);

    autoTable(doc, {
      startY: 50,
      head: [columns.map((col) => col.label)],
      body: data.map((row) => columns.map((col) => row[col.key])),
      theme: "striped",
      headStyles: { fillColor: [22, 160, 133] },
    });

    doc.save(`${fileName}.pdf`);
  };
};
